import component from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-shift-discomfort/lni-janitorial-shift-discomfort.component.vue';
import module from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-shift-discomfort/lni-janitorial-shift-discomfort.module.js';

export default {
    component,
    module,
};